import { render, staticRenderFns } from "./ReportAdditonalInformationHueffermann.vue?vue&type=template&id=dd5eba40&scoped=true&"
import script from "./ReportAdditonalInformationHueffermann.vue?vue&type=script&lang=ts&"
export * from "./ReportAdditonalInformationHueffermann.vue?vue&type=script&lang=ts&"
import style0 from "./ReportAdditonalInformationHueffermann.vue?vue&type=style&index=0&id=dd5eba40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5eba40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VForm,VTextField})
